/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { FilterableByLocation } from '../../interface/models';

export const isFilterableByLocation = (item: unknown): item is FilterableByLocation => {
  if (!item) {
    return false;
  }

  return Boolean(
    typeof item === 'object' &&
    'location_filter_enabled' in item &&
    item.location_filter_enabled &&
    'location_filter' in item &&
    item.location_filter &&
    typeof item.location_filter === 'object',
  );
};
